import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = route => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const code = route.queryParams['code'];

  if (code) {
    authService.getAzureADToken(code).subscribe(async (response: any) => {
      localStorage.setItem('hubapi-web-user-credential', JSON.stringify(response));
      router.navigate(['/']);
    });
  } else {
    const isAuthenticated = localStorage.getItem('hubapi-web-user-credential');

    if (!isAuthenticated) {
      window.location.href = getRedirectLoginUrl();
    }
  }

  return true;
};

const getRedirectLoginUrl = () => {
  return `${environment.azureBaseUrl
    .replace(':tenant', environment.tenant)
    .replace(':tenant', environment.tenant)}/authorize?p=${environment.azurePolicy}&client_id=${
    environment.azureClientId
  }&nonce=defaultNonce&redirect_uri=${window.origin}&scope=openid ${environment.scope}&response_type=code&prompt=login`;
};
